<template>
  <div class="card">
    <div class="card-body">
      <div class="row" v-if="is_loading == false">
        <div class="col text-left">
          <div class="row">
            <div class="col">
              <span class="text-bold">
                Telefone:
                <span class="text-normal">{{ phone }}</span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="text-bold">
                Nome:
                <span class="text-normal">{{ destiny.data.address.name.toUpperCase() }}</span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="text-bold">
                Endereço:
                <span
                  class="text-normal"
                >{{ destiny.data.address.description.toUpperCase() }}</span>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <span class="text-bold">
                Número:
                <span class="text-normal">{{ destiny.data.address.number.toUpperCase() }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-auto">
          <div class="row">
            <div class="col aling-center">{{ fthour }}</div>
          </div>
          <div class="row">
            <div class="col aling-center">{{ ftdate }}</div>
          </div>
        </div>
        <div class="col-md-auto">
          <div class="dropdown">
            <button
              class="btn btn-secondary dropdown-toggle mobile"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >Opções</button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                href="#"
                onclick="return false;"
                v-on:click="deleteDestiny()"
              >Excluir cliente</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col">
          <div class="loader"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../configs/firebase.js";
import moment from 'moment-timezone';

export default {
  name: "Destiny",
  props: {
    destiny: Object
  },
  data() {
    return {
      is_loading: false
    };
  },
  computed: {
    fthour: function() {
      try {
        return moment(this.destiny.data.dates.create).format('HH:mm');
      } catch (e) {
        //console.log(e);
        return "--:--";
      }
    },
    ftdate: function() {
      try {
        return moment(this.destiny.data.dates.create).format('DD/MM/YYYY');
      } catch (e) {
        //console.log(e);
        return "--/--/----";
      }
    },
    phone: function() {
      try {
        return this.destiny.data.keys.user_phone.split("|")[1];
      } catch (e) {
        //console.log(e);
        return "Sem telefone";
      }
    },
    user: function() {
      return this.$root.user;
    }
  },
  mounted() {},
  methods: {
    async deleteDestiny() {
      try {
        this.is_loading = true;

        await db.ref('destiny_adresses/' + this.destiny.key).remove();

        alert("Cliente excluido com sucesso");

        this.$emit('exclude', this.destiny.key);
      } catch (e) {
        //console.log(e);
        alert("Erro, não conseguimos excluir esse cliente, tente novamente");
      } finally {
        this.is_loading = false;
      }
    }
  }
};
</script>